interface TrackInfo {
    title: string;
    description: string;
    authors: string;
    worksType: string;
    finalChosen: boolean;
}

export const infoData: Record<string, TrackInfo> = {
    callToMe: {
        title: "Call To Me",
        description:
            "Call To Me was the first track I put together. Call To Me is the only track where both the male and female vocalists sing at the same pitch. As it was generally agreed the female vocal performance was stronger than the male, the track was ultimately not included in the final survey study. Despite this, it remains one of my favourite tracks.",
        authors:
            "Music by Ovani Music. Lyrics and vocal arrangement by Dragonshifty Studios.",
        worksType: "Licensed bed. Vocal performance Ace Studio.",
        finalChosen: false,
    },
    shine: {
        title: "Shine",
        description:
            "The second track I did for the study. It wasn't included in the final study, but it means quite a bit to me. It's about instilling confidence in yourself.",
        authors:
            "Ovani Music. Lyrics and vocal arrangement by Dragonshifty Studios.",
        worksType: "Licensed bed. Vocal performance Ace Studio.",
        finalChosen: false,
    },
    fine: {
        title: "Fine",
        description:
            "Probably my favourite song, both in terms of narrative and that I thought it was time for the two vocalists to duet with each other. Sometimes it's the trivial things can mean a lot.",
        authors:
            "INEEDMUSIC.CO. Lyrics and vocal arrangement by Dragonshifty Studios.",
        worksType: "Licensed bed. Vocal performance Ace Studio.",
        finalChosen: true,
    },
    myOwnExpectations: {
        title: "My Own Expectations",
        description:
            "My Own Expectations was a lot of fun to record. The drum part was written first, which seemed to go well with a bass line I've had kicking about in my head for a while. I also wanted the small lead guitar part to be slightly anarchical. Unlike the other tracks where I had a clear picture of what the story is, this was more stream of conciousness, and I'll probably work out what it's about later.",
        authors: "Dragonshifty Studios.",
        worksType:
            "Composition by Dragonshifty Studios. Vocal Performance by Ace Studio.",
        finalChosen: true,
    },
    myOne: {
        title: "My One",
        description:
            "I love both vocalists' performances on this one. The timing structure for the vocals is also more free-form. I'll leave it up to the listener to create their own narrative.",
        authors:
            "Still trying to find where I purchased this from. If you're the composer, let me know. Lyrics and vocal arrangement by Dragonshifty Studios.",
        worksType: "Licensed bed. Vocal performance Ace Studio.",
        finalChosen: true,
    },
    flyOn: {
        title: "Fly On",
        description:
            "Fly On starts with a chorus. In terms of feedback, this turned out to be the most popular track.",
        authors:
            "Still trying to find where I purchased this from. If you're the composer, let me know. Lyrics and vocal arrangement by Dragonshifty Studios.",
        worksType: "Licensed bed. Vocal performance Ace Studio.",
        finalChosen: true,
    },
    clearly: {
        title: "Clearly",
        description:
            "A fusion of rock and drum and bass, with an agressive vocal narrative. I see this as the rocky one, where as my wife sees it as more drum and bass.",
        authors:
            "Music by Andy Ray. Lyrics and vocal arrangement by Dragonshifty Studios.",
        worksType: "Licensed bed. Vocal performance Ace Studio.",
        finalChosen: true,
    },
    dreamWistfully: {
        title: "Dream Wistfully",
        description:
            "This was the last track I wrote for the study, and I very much enjoyed the more chilled vibe. I joked with my wife that I'd probably end up writing some trip hop at the start of this adventure. I hope I've in some way achieved this.",
        authors: "Dragonshifty Studios.",
        worksType: "Composition by Dragonshifty Studios.",
        finalChosen: true,
    },
    rising: {
        title: "Rising",
        description:
            "This song is probably the most me. I recorded it with strings that were deliberately old and buzzy to try and give it that characteristic old guitar that you find lying around sound. Recorded with two mics - an SE Eletronics se2000 and a Rode NT5 - and my florentine-cut acoustic guitar that was handmade for me (a bit different to the floating dreadnaught guitar pictured).",
        authors: "Dragonshifty Studios.",
        worksType: "Composition by Dragonshifty Studios.",
        finalChosen: true,
    },
    triggered: {
        title: "Triggered",
        description:
            "This was a ton of fun to do as something otherwise outside my usual genres. One participant who seemingly hated everything else really liked this. Written with loops I purchased a while ago. All about the build-up.",
        authors: "Dragonshifty Studios.",
        worksType: " Composition by Dragonshifty Studios.",
        finalChosen: true,
    },
    dreamWistfullyDiscovery: {
        title: "Dream Wistfully Discovery",
        description:
            "This version of Dream Wistfully wasn't presented in the final surveys, in part because I couldn't find any female chatter astronaut chatter to use, which could possibly have given an unintentional bias.",
        authors:
            "Dragonshifty Studios. Voice property of NASA (not commercial use).",
        worksType: "Composition by Dragonshifty Studio",
        finalChosen: false,
    },
};
